import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a6d7ccf0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a6d7ccf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7ccf0",
  null
  
)

export default component.exports